const getErrorMessage = error => {
  if(!error.response) {
    return 'Network error'
  }
  return error.response.data
}

export default getErrorMessage
